export class InvestigationInvolvedEmployeeEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public phone?: string | null;
  public isActive = true;
}
